import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import * as _ from 'lodash';
import { IFeature, IFeatureFilter } from "./features.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class FeaturesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getFeatures(filter?: IFeatureFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_FEATURES)}${queryParams}`);
  }

  getFeature(feature: IFeature | string): Observable<any> {
    let id = (typeof feature == 'string') ? feature : feature._id;
    return this._http.get(`${apiURL(EnvConfig.API_FEATURES)}/${id}`);
  }

  createFeature(feature: IFeature): Observable<any> {
    delete feature._id;
    return this._http.post(`${apiURL(EnvConfig.API_FEATURES)}`, feature);
  }

  updateFeature(feature: IFeature): Observable<any> {
    let id = feature._id;
    delete feature._id;
    return this._http.patch(`${apiURL(EnvConfig.API_FEATURES)}/${id}`, feature);
  }

  deleteFeature(feature: IFeature | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof feature == 'string') ? feature : feature._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_FEATURES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_FEATURES)}/${id}/delete`);
  }

  restoreFeature(feature: IFeature | string): Observable<void> {
    let id = (typeof feature == 'string') ? feature : feature._id;
    return this._http.patch(`${apiURL(EnvConfig.API_FEATURES)}/${id}/restore`, null);
  }
}